import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column is-one-quarter" }
const _hoisted_2 = { class: "column is-three-quarter conteudo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuLateral = _resolveComponent("MenuLateral")!
  const _component_Notificacoes = _resolveComponent("Notificacoes")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["columns is-gapless is-multiline", { 'modo-escuro': _ctx.modoEscuroAtivo }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MenuLateral, { onAoTemaAlterado: _ctx.toggleTema }, null, 8, ["onAoTemaAlterado"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Notificacoes),
      _createVNode(_component_router_view)
    ])
  ], 2))
}